import { render } from "./Viewer3D.vue?vue&type=template&id=85c50498&scoped=true"
import script from "./Viewer3D.vue?vue&type=script&js=true&lang=js"
export * from "./Viewer3D.vue?vue&type=script&js=true&lang=js"

import "./Viewer3D.vue?vue&type=style&index=0&id=85c50498&scoped=true&lang=css"
import "./Viewer3D.vue?vue&type=style&index=1&id=85c50498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c50498"]])

export default __exports__